import React from 'react';

import Config from '../config/Config';
import WidgetAjax from '../widget/WidgetAjax';
import WidgetTimeLine from '../widget/WidgetTimeLine';

import '../css/analysis.css';

class ObjectDynamicCourse extends React.Component 
{
    constructor(props) 
    {
        super(props);

        let user = Config.getHermesPanoramaUID();
        let url = Config.getHermesPanoramaURL();

        this.state = {
            url: url,
            entname : this.props.ENTNAME,
            data: undefined,
            params: {
                user: user
            },
            loading:true
        }

        this.loadData = this.loadData.bind(this);
        this.onLoadData = this.onLoadData.bind(this);
        this.onLoadToken = this.onLoadToken.bind(this);
    }

    componentDidMount()
    {
        Config.getHermesAccess(this.onLoadToken);
    }

    componentWillReceiveProps( nextProps )
    {
        let { entname } = this.state;

        if( entname!==nextProps.ENTNAME )
        {
            this.state["entname"] = nextProps.ENTNAME;

            Config.getHermesAccess(this.onLoadToken);
        }
    }

    onLoadToken(result) 
    {
        if (result.status === 0) 
        {
            this.state["params"]["access"] = result.result.token;

            this.loadData();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props.parentProps);
        }
    }

    loadData() 
    {
        const { url, params, entname, item } = this.state;

        if (entname === undefined) 
        {
            params["ENTNAME"] = item.NAME;
        } 
        else 
        {
            params["ENTNAME"] = entname;
        }

        WidgetAjax.ajax({ url: url, params: { ...params, ...{ "service": "getChronicleInfo" } }, callback: this.onLoadData, backParam: { params: {} } });
        this.setState({ loading: true });
    }

    onLoadData(result, params) 
    {
        if ( result.status===0 ) 
        {
            let data = [];
            for (let item of result.results) 
            {
                let itemData = {};

                itemData["time"] = item.MONTH;
                itemData["title"] = item.TYPE;
                itemData["type"] = item.ACTION;
                itemData["content"] = item.CONTENT;
                itemData["description"] = item.DESCRIPTION;

                data.push(itemData);

                this.setState({ data: data, loading:false });
            }
        }
        else if ( result.status===10 ) 
        {
            Cache.logout(this.props.parentProps);
        }
    }

    render()
    {
        const {  data, entname, loading } = this.state;

        return (
            <div className="page page-overflow">
                <div className="content padding-0 white" style={{ minHeight: '100%', height: 'auto' }}>
                    {/* <div className="content-operation" style={{ margin: '0px', padding: '0 20px' }}>
                        <div className="account-title"  onClick={ this.labelChange}>{entname}</div>
                        <label className="Monitoring-warning click" onClick={this.labelChange} >企业概况</label>
                    </div> */}
                    {loading?<div className="img-loading"><img src={require('./../img/frame/loading.gif')} className="loading-detail" alt="es-lint want to get"/></div>:
                        <div className="content-body" style={{ height: 'auto', padding: '11px 24px 0 24px' }}>
                            {data===undefined?<p style={{width:"100%",textAlign:"center",paddingTop:"100px"}}><img src={require('../css/widget/img/no-data.svg')}></img></p>:
                                <WidgetTimeLine data={data}></WidgetTimeLine>
                            }
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default ObjectDynamicCourse
